// extracted by mini-css-extract-plugin
export default {"formBox":"qSiOdDrURlINbAEnBRAL"};